import { render } from "./ListeFournisseur.vue?vue&type=template&id=9c488404&ts=true"
import script from "./ListeFournisseur.vue?vue&type=script&lang=ts"
export * from "./ListeFournisseur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__